import moment from 'moment-timezone';

const MAX_PAST_YEARS = 2;

/**
 * Cashier transactions older than two years are no longer relevant, so both the
 * page and export datepickers forbid selecting a date earlier than that.
 */
const getTransactionsMaxPastDate = (timezone = 'Europe/Paris') =>
  moment.tz(timezone).subtract(MAX_PAST_YEARS, 'years');

export default { getTransactionsMaxPastDate };
